// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyAyqPt4l5Qahtyxh1zmrP-ZcfNtVCIOw2o',
  authDomain: 'bitrise-website.firebaseapp.com',
  projectId: 'bitrise-website',
  storageBucket: 'bitrise-website.firebasestorage.app',
  messagingSenderId: '670990918917',
  appId: '1:670990918917:web:570ec0588e0640d991c36c',
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

const firebaseMessaging = getMessaging(firebaseApp);

export { firebaseApp, firebaseMessaging };
